import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button, Table, Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MainServices = () => {
    const [mainServices, setMainServices] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState("add");
    const [formData, setFormData] = useState({ title: "", image: null, id: null });
    const [serviceTypes, setServiceTypes] = useState([])
    const [filteredTypes, setFilteredTypes] = useState([])



    const fetchMain = () => {
        axios
            .get("https://api.glyphqai.com/api/get-mainservice")
            .then((response) => {
                if (response.data.status === 200) {
                    setMainServices(response.data.main_services);
                    setFilteredTypes(response.data.main_services);
                }
            })
            .catch((error) => console.error("Error fetching main services:", error));
    };

    useEffect(() => {
        const fetchTypes = async () => {
            try {

                const response = await axios.get('https://api.glyphqai.com/api/get-servicetype')
                setServiceTypes(response.data.service_type);

            } catch (err) {
                console.error('Error fetching service types: ', err)
            }
        }
        fetchTypes();
        fetchMain();
    }, [])

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        setFormData({ ...formData, image: e.target.files[0] });
    };

    const handleOpenModal = (type, service = null) => {
        setModalType(type);

        if (type === "edit" && service) {
            setFormData({
                title: service.title,
                image: null,
                id: service.id,
                service_type_id: service.service_id, // Set correct service type ID
            });
        } else {
            setFormData({
                title: "",
                image: null,
                id: null,
                service_type_id: "", // Reset the dropdown selection
            });
        }

        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const formPayload = new FormData();
        formPayload.append("title", formData.title);
        formPayload.append("service__type_id", formData.service_type_id);
        if (formData.image) {
            formPayload.append("image", formData.image);
        }

        if (modalType === "add") {
            // Use FormData for POST

            axios
                .post("https://api.glyphqai.com/api/store-mainservice", formPayload, {
                    headers: { "Content-Type": "multipart/form-data" },
                })
                .then(() => {
                    toast.success("Main service added successfully!");
                    axios
                        .get("https://api.glyphqai.com/api/get-mainservice")
                        .then((response) => setMainServices(response.data.main_services));
                    handleCloseModal();
                })
                .catch((error) => {
                    console.error("Error storing main service:", error);
                    toast.error("Failed to add main service.");
                });
        } else if (modalType === "edit") {
            // Use JSON for PUT
            formPayload.append("_method", "PUT")


            axios
                .post(
                    `https://api.glyphqai.com/api/update-mainservice/${formData.id}`,
                    formPayload,
                    // {
                    //     headers: { "Content-Type": "application/json" },
                    // }
                )
                .then(() => {
                    toast.success("Main service updated successfully!");
                    axios
                        .get("https://api.glyphqai.com/api/get-mainservice")
                        .then((response) => setMainServices(response.data.main_services));
                    handleCloseModal();

                })
                .catch((error) => {
                    console.error("Error updating main service:", error);
                    toast.error("Failed to update main service.");
                });
        }

        fetchMain();
    };

    const handleDelete = (id) => {
        axios
            .delete(`https://api.glyphqai.com/api/deletemainservice/${id}`)
            .then(() => {
                setMainServices(mainServices.filter((service) => service.id !== id));
                toast.success("Main service deleted successfully!");
            })
            .catch((error) => {
                console.error("Error deleting main service:", error);
                toast.error("Failed to delete main service.");
            });
    };

    const handleFilterChange = (e) => {
        if (e.target.value === "all") {
            setFilteredTypes(mainServices)
        } else {
            setFilteredTypes(mainServices.filter((service) => service.service_id == e.target.value));
        }
    }

    return (
        <>
            <div className="container">
                <div className="my-3 mt-5 d-flex justify-content-between">
                    <h2 className="font-bold display-5">Main Services</h2>
                    <Button
                        onClick={() => handleOpenModal("add")}
                        className="mb-3"
                    >
                        Add Main Service
                    </Button>
                </div>
                <div>
                    <h3 className="font-semibold">Filter By Type:</h3>
                    <Form.Select className="mb-5" onChange={handleFilterChange}>
                        <option value="all">All Service Types</option>
                        {serviceTypes.map((service) => (<option value={service.id}>{service.title}</option>))}
                    </Form.Select>
                </div>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th className="text-center">#</th>
                            <th>Title</th>
                            <th>Image</th>
                            <th>Service Type</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredTypes.map((service, index) => (
                            <tr key={service.id}>
                                <td className="text-center">{index + 1}</td>
                                <td>{service.title}</td>
                                <td>
                                    <img
                                        src={`https://api.glyphqai.com/uploads/mainservices/${service.image}`}
                                        alt={service.title}
                                        style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                    />
                                </td>
                                <td>{serviceTypes.find((s) => s.id === service.service_id)?.title}</td>
                                <td>
                                    <Button
                                        onClick={() => handleOpenModal("edit", service)}
                                    >
                                        Edit
                                    </Button>{" "}
                                    <Button variant="danger" onClick={() => handleDelete(service.id)}>
                                        Delete
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {modalType === "add" ? "Add Main Service" : "Edit Main Service"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mt-3">
                            <Form.Label>Service Type</Form.Label>
                            <Form.Select
                                name="service_type_id"
                                id="service_type_id"
                                value={formData.service_type_id} // Corrected this line
                                onChange={handleInputChange}
                            >
                                <option value="">Select a type</option>
                                {serviceTypes.map((service) => (
                                    <option key={service.id} value={service.id}>
                                        {service.title}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group controlId="formTitle" className="mt-3">
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter title"
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="formImage" className="mt-3">
                            <Form.Label>Image</Form.Label>
                            <Form.Control
                                type="file"
                                name="image"
                                onChange={handleFileChange}
                                required={modalType === "add"}
                            />
                        </Form.Group>
                        <Button
                            type="submit"
                            className="mt-3"
                        >
                            {modalType === "add" ? "Add Main Service" : "Update Main Service"}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

            <ToastContainer />
        </>
    );
};

export default MainServices;
